<template>
  <div class="datePicker">
    <h2>{{ title }}</h2>

    <div class="date">
      <v-icon @click="previousWeek">mdi-arrow-left</v-icon>
      <h3>
        <!-- {{ months[date.getMonth()] + " " + date.getFullYear() }} -->
        {{ selectedMonth }}, {{ selectedYear }}
      </h3>
      <v-icon @click="nextWeek">mdi-arrow-right</v-icon>
    </div>
    <div class="weekDays">
      <div
        v-for="(day, i) in generatedDays"
        :key="i"
        :class="[
          { check: day.format('D') === selectedDate.format('D') },
          { weekend: day[0] === 'Sam' || day[0] === 'Dim' },
        ]"
        @click="selectDate(day)"
      >
        <div class="text-capitalize">
          {{ day.format("ddd") }}
        </div>
        <div>{{ day.get("date") }}</div>
      </div>
    </div>
    <div class="hours">
      <div
        v-for="(time, i) in generateTimes"
        :key="i"
        :class="[{ check: time === selectedTime }]"
        @click="selectTime(time)"
      >
        {{ time }}
      </div>
    </div>

    <!-- Alert -->
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  model: {
    prop: "data",
    event: "change",
  },
  props: {
    data: { default: "" },
    title: {
      type: String,
    },
  },
  data() {
    return {
      date: moment(),
      selectedDate: null,
      selectedTime: null,
    };
  },
  name: "DatePicker",
  computed: {
    selectedMonth() {
      return this.date.format("MMMM");
    },
    selectedYear() {
      return this.date.format("YYYY");
    },
    ...mapGetters(["isLoggedIn"]),
    generatedDays() {
      moment.locale("fr");
      var current = moment(this.date);

      var weekStart = moment(this.date);
      var weekEnd = current.clone().endOf("isoWeek");

      this.selectedDate = weekStart;

      return this.generateWeek(weekStart);
    },
    generateTimes() {
      var startTime = moment("08:00", "HH:mm");
      var endTime = moment("23:30", "HH:mm");

      if (endTime.isBefore(startTime)) {
        endTime.add(1, "day");
      }
      var timeStops = [];
      while (startTime <= endTime) {
        timeStops.push(new moment(startTime).format("HH:mm"));
        startTime.add(30, "minutes");
      }
      return timeStops;
    },
  },
  methods: {
    selectDate(i) {
      console.log(i, this.selectedDate);
      if (this.selectedDate === i) {
        this.selectedDate = null;
        this.selectedTime = null;
        this.$emit("change", null);
      } else {
        this.selectedDate = i;
        console.log(this.selectedDate, i);
        this.$emit(
          "change",
          moment(
            moment(
              moment(this.selectedDate).format("YYYY/MM/DD") + " " + this.selectedTime
            ).format()
          ).local(true)
        );
      }
    },
    selectTime(i) {
      console.log("selected time ", i);
      if (this.isLoggedIn) {
        if (this.selectedDate)
          if (this.selectedTime === i) {
            this.selectedTime = null;
            this.$emit("change", null);
          } else {
            this.selectedTime = i;
            this.$emit(
              "change",
              moment(
                moment(
                  moment(this.selectedDate).format("YYYY/MM/DD") +
                    " " +
                    this.selectedTime
                ).format()
              ).local(true)
            );
          }
      } else {
        this.$store.dispatch("setSnackAlert", {
          status: true,
          message: "Test",
          success: false,
        });
      }
    },
    nextWeek() {
      this.date = this.generatedDays[0].add(7, "days");
      this.generatedDays;
      this.selectedDate = this.date;
    },
    previousWeek() {
      moment.locale("fr");
      this.date = this.generatedDays[0];
      var current = moment();
      if (current < moment(this.date)) {
        this.date = this.generatedDays[0].subtract(7, "days");
        this.generatedDays;
      }
    },
    generateWeek(firstDate) {
      var days = [];
      for (var i = 0; i <= 6; i++) {
        days.push(moment(firstDate).add(i, "days"));
      }
      return days;
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300&display=swap");
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}
.datePicker {
  width: 100%;
  height: auto;
  background-color: #fff;
  text-align: center;
  border: 1px solid #e2e2e2;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
  border-radius: 6px;
}
.weekDays {
  display: flex;
  justify-content: space-around;
  padding: 10px;
}
.weekDays > div {
  box-shadow: 0px 7px 10px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  width: 60px;
  height: 55px;
  background-color: #fdfdfd;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  border-radius: 5px;
  font-size: 14px;
  color: #938f8f;
}
.check {
  background-color: #e91e24 !important;
  color: white !important;
  box-shadow: 0px 7px 10px rgba(0, 0, 0, 0.1);
}
.weekDays .check div {
  color: white !important;
}
.weekend {
  background-color: #f2dede !important;
  border: 1px solid red !important;
  color: #938f8f !important;
}
.weekDays > div > div:nth-child(2) {
  font-weight: bolder;
  font-size: 1.25em;
  color: black;
}
.hours {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: 20px;
  margin-right: 9px;
}
.hours > div {
  cursor: pointer;
  margin-left: 6px;
  background-color: #f5f5f5;
  padding: 5px 20px;
  border-radius: 4px;
  font-weight: bolder;
  color: #797979;
  margin-bottom: 7px;
  font-size: 15px;
}
h2 {
  padding: 10px;
  font-size: 20px;
}
.date {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}
.date > h3 {
  flex: 2;
  padding-left: 20px;
}
</style>
